export const cdp = {
	tabs: {
		dashboard: "Painel CDP",
		customers: "Lista de Clientes",
		rfmAnalysis: "Análise RFM",
		segments: "Segmentos",
	},
	dashboard: {
		title: "Painel CDP",
		subtitle:
			"Acompanhe seus clientes, métricas de relacionamento e segmentação inteligente",
		filters: {
			period: {
				label: "Período",
				options: {
					last7Days: "Últimos 7 dias",
					last15Days: "Últimos 15 dias",
					last30Days: "Últimos 30 dias",
					last60Days: "Últimos 60 dias",
					last90Days: "Últimos 90 dias",
				},
			},
			groupBy: {
				label: "Agrupar por",
				options: {
					week: "Semana",
					month: "Mês",
				},
			},
			establishments: {
				label: "Estabelecimentos",
				all: "Todos",
			},
		},
	},
	customers: {
		title: "Lista de Clientes",
		subtitle: "Busque e filtre clientes da sua base",
		filters: {
			search: {
				placeholder: "Buscar por documento...",
			},
			rfmClassification: {
				label: "Classificação RFM",
				placeholder: "Todas as classificações",
			},
			segments: {
				label: "Segmentos",
				placeholder: "Todos os segmentos",
			},
			allowCommunication: {
				label: "Permite Comunicação",
				all: "Todos",
				yes: "Sim",
				no: "Não",
			},
			lastInteraction: {
				label: "Última Interação",
				last7Days: "Últimos 7 dias",
				last30Days: "Últimos 30 dias",
				moreThan90Days: "Mais de 90 dias",
				custom: "Personalizado",
			},
			balance: {
				label: "Saldo Disponível",
				onlyWithBalance: "Somente com saldo",
				minBalance: "Saldo mínimo (R$)",
			},
			activityPeriod: {
				label: "Período de Atividade",
				from: "De",
				to: "Até",
			},
			actions: {
				apply: "Aplicar Filtros",
				clear: "Limpar Filtros",
			},
			results: "{{count}} clientes encontrados",
		},
		table: {
			columns: {
				name: "Nome",
				contact: "Contato",
				classification: "Classificação",
				behavior: "Comportamento",
				totalPaid: "Total pago",
				averageTicket: "Tkt Médio",
				actions: "Ações",
			},
			visits: "{{count}} visitas",
			lastVisit: "Última visita",
			ago: "há {{days}} dias",
			totalPaid: "Total pago",
			averageTicket: "Ticket médio",
			balance: "Saldo",
			viewDetails: "Ver Detalhes",
			noResults: "Nenhum cliente encontrado",
			noResultsDescription: "Tente ajustar os filtros para encontrar clientes",
		},
		status: {
			active: "Ativo",
			attention: "Atenção",
			risk: "Risco",
			inactive: "Inativo",
		},
		drawer: {
			title: "Detalhes do Cliente",
			tabs: {
				summary: "Resumo",
				favoriteProducts: "Produtos Favoritos",
				history: "Histórico",
				purchases: "Compras",
			},
			summary: {
				personalData: "Dados Pessoais",
				document: "Documento",
				email: "Email",
				phone: "Telefone",
				birthDate: "Data de Nascimento",
				gender: "Gênero",
				city: "Cidade",
				allowsCommunication: "Permite Comunicação",
				activitySummary: "Resumo de Atividade",
				firstVisit: "Primeira Visita",
				lastVisit: "Última Visita",
				totalVisits: "Total de Visitas",
				averageFrequency: "Frequência Média",
				visitsPerMonth: "visitas/mês",
				customerFor: "Cliente há {{days}} dias",
				financial: "Financeiro",
				totalPaid: "Total Pago",
				averageTicket: "Ticket Médio",
				availableBalance: "Saldo Disponível",
				classifications: "Classificações",
				rfmByPlace: "RFM por Estabelecimento",
				segments: "Segmentos",
			},
			products: {
				product: "Produto",
				category: "Categoria",
				quantity: "Quantidade",
				totalValue: "Valor Total",
				lastPurchase: "Última Compra",
				percentageOfPurchases: "% das Compras",
				noProducts: "Nenhum produto favorito encontrado",
			},
			history: {
				filterByType: "Filtrar por tipo",
				allTypes: "Todos os tipos",
				loadMore: "Carregar mais",
				noHistory: "Nenhum histórico encontrado",
			},
			purchases: {
				product: "Produto",
				category: "Categoria",
				quantity: "Qtd",
				unitPrice: "Preço Unit.",
				total: "Total",
				date: "Data",
				noPurchases: "Nenhuma compra encontrada",
				loadMore: "Carregar mais",
			},
			actions: {
				close: "Fechar",
				addToSegment: "Adicionar a Segmento",
				edit: "Editar",
			},
		},
		genders: {
			male: "Masculino",
			female: "Feminino",
			other: "Outro",
			unknown: "Não informado",
		},
		interactionTypes: {
			presence: "Presença",
			recharge: "Recarga",
			giftbackRescue: "Resgate Giftback",
			giftbackExpire: "Expiração Giftback",
			giftbackReceive: "Recebimento Giftback",
			ticketPurchase: "Compra Ingresso",
			ticketCancel: "Cancelamento Ingresso",
			communication: "Comunicação",
			rfmMigration: "Migração RFM",
		},
	},
	segments: {
		title: "Segmentos",
		subtitle: "Crie e gerencie segmentos customizados de clientes",
		summary: {
			highestRevenue: "Segmento com maior receita",
			highestTicket: "Segmento com maior ticket médio",
			mostCustomers: "Segmento com mais clientes",
			leastCustomers: "Segmento com menos clientes",
		},
		search: {
			placeholder: "Buscar segmento...",
		},
		actions: {
			create: "Criar segmentação",
			edit: "Editar",
			delete: "Excluir",
			duplicate: "Duplicar",
		},
		card: {
			createdBy: "Criado por: {{name}}",
			leads: "{{count}} leads",
			lastSync: "Última sincronização: {{date}}",
			neverSynced: "Nunca sincronizado",
		},
		drawer: {
			titleCreate: "Criar segmento",
			titleEdit: "Editar segmento",
			fields: {
				name: "Nome",
				namePlaceholder: "Nome do segmento",
				description: "Descrição",
				descriptionPlaceholder: "Descreva o objetivo deste segmento",
				analysisPeriod: "Período de análise (dias)",
				analysisPeriodPlaceholder: "Ex: 30",
			},
			rules: {
				title: "Regras de Segmentação",
				demographic: "Demográficas",
				consumption: "Consumo",
				engagement: "Engajamento",
				status: "Status",
				gender: {
					label: "Gênero",
					male: "Masculino",
					female: "Feminino",
					other: "Outro",
				},
				birthday: {
					label: "Aniversário",
					thisMonth: "Este mês",
					nextMonth: "Próximo mês",
					thisWeek: "Esta semana",
					nextWeek: "Próxima semana",
				},
				minFrequency: {
					label: "Frequência mínima",
					placeholder: "Mínimo de compras no período",
				},
				minPresences: {
					label: "Visitas mínimas",
					placeholder: "Mínimo de visitas no período",
				},
				minTotalPaid: {
					label: "Valor total mínimo",
					placeholder: "R$ 0,00",
				},
				minAvgTicket: {
					label: "Ticket médio mínimo",
					placeholder: "R$ 0,00",
				},
				maxLastInteraction: {
					label: "Tempo desde última compra",
					placeholder: "Máximo de dias",
					suffix: "dias",
				},
				minRemainingBalance: {
					label: "Saldo mínimo disponível",
					placeholder: "R$ 0,00",
				},
				rfmClassification: {
					label: "Classificação RFM",
					placeholder: "Selecione uma classificação",
				},
			},
			actions: {
				save: "Salvar",
				cancel: "Cancelar",
				saving: "Salvando...",
			},
			validation: {
				nameRequired: "Nome é obrigatório",
				descriptionRequired: "Descrição é obrigatória",
				analysisPeriodRequired: "Período de análise é obrigatório",
				analysisPeriodMin: "Período deve ser maior que 0",
			},
		},
		deleteModal: {
			title: "Excluir segmento",
			message:
				'Tem certeza que deseja excluir o segmento "{{name}}"? Esta ação não pode ser desfeita.',
			confirm: "Excluir",
			cancel: "Cancelar",
			deleting: "Excluindo...",
		},
		empty: {
			title: "Nenhum segmento encontrado",
			description: "Crie seu primeiro segmento para começar a organizar seus clientes.",
			searchEmpty: "Nenhum segmento corresponde à sua busca.",
		},
		toast: {
			createSuccess: "Segmento criado com sucesso",
			updateSuccess: "Segmento atualizado com sucesso",
			deleteSuccess: "Segmento excluído com sucesso",
		},
	},
};
